import { IUser, Id, UserOptionResource } from "@dgs/core";
import { BottomNavBarItemOptionResource } from "../types/bottomNavBarItem";
import { EventOptionResource } from "../types/event";
import { RecipientRequest, RecipientType } from "../types/recipient";

export enum AppNotificationActionType {
	NONE = "none",
	OPEN_TAB = "openTab",
	OPEN_WEBSITE = "openWebsite",
	OPEN_EVENT = "openEvent",
	REGISTRATION_LINK = "registrationLink",
}

export interface AppNotificationFormValues {
	title: string;
	body: string;
	selectedRecipients: IUser[];
	event: EventOptionResource | null;
	recipientType: RecipientType;
	actionType: AppNotificationActionType;
	actionValue: BottomNavBarItemOptionResource | EventOptionResource | string | undefined;
	showSendAt: boolean;
	sendAt: string | null;
}

export interface AppNotificationRequest {
	title: string;
	body: string;
	recipientType: RecipientType;
	recipients: RecipientRequest;
	action: AppNotificationActionRequest;
	sendAt: string | null;
}

export interface AppNotificationActionRequest {
	type: AppNotificationActionType;
	data: AppNotificationActionDataRequest | null;
}

export interface AppNotificationActionDataRequest {
	url?: string;
	eventId?: number;
	bottomNavBarItemId?: number;
}

export type AppNotificationStatus = "error" | "sent" | "scheduled" | "inProgress";

export interface AppNotificationIndexResource {
	id: Id;
	title: string;
	status: AppNotificationStatus;
	author: UserOptionResource | null;
	sendAt: string | null;
	sentAt: string | null;
}

export interface AppNotificationUpdateResource {
	id: Id;
	title: string;
	body: string;
	selectedRecipients: IUser[];
	event: EventOptionResource | null;
	recipientType: RecipientType;
	actionType: AppNotificationActionType;
	actionValue: BottomNavBarItemOptionResource | EventOptionResource | string | undefined;
	showSendAt: boolean;
	sendAt: string | null;
	status: AppNotificationStatus;
}
